<template>
  <a-row :gutter="20" class="setup-share-story">
    <a-col :class="settings.isMenuCollapsed ? 'toggled' : 'unfixed'">
      <a-spin :spinning="progress >= 0" :tip="`Uploading ${progress}%`" size="large">
        <div class="spin-content">
          <a-card :title="$t('cardTitle.uploadProfileVideo')" class="style3 text-center">
            <a-row v-if="!videoFile">
              <a-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 20, offset: 2 }" :md="{ span: 16, offset: 4 }" :xl="{ span: 12, offset: 6 }">
                <div class="responsive-embed">
                  <iframe :src="instructionVideo('SYJS_RECRUITMENT')" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                </div>
                <a-row :gutter="20" class="mt-5" style="display: flex; justify-content: center">
                  <a-col :md="{ span: 8 }" :sm="{ span: 24 }">
                    <a-button type="primary" class="tf-btn tf-btn-primary mb-4" @click="e => $refs.videoPicker.click()"> <a-icon type="upload" />Upload Video </a-button>
                    <input type="file" style="width: 0; height: 0" accept="video/mp4,video/x-m4v,video/*" ref="videoPicker" @change="videoSelectChange" />
                  </a-col>
                  <a-col :md="{ span: 8 }" :sm="{ span: 24 }">
                    <a-button type="primary" class="tf-btn tf-btn-primary mb-4" @click="captureVideo">
                      <inline-svg :src="require('../../assets/images/record-video.svg')" width="18" height="12" />
                      <span style="margin-left: 4px">Capture Profile Video</span>
                    </a-button>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-row v-else :gutter="20">
              <a-col :md="{ span: 16, offset: 4 }" :sm="{ span: 24 }">
                <a-card hoverable v-if="videoFile">
                  <div class="player-wrapper mt-2" style="background: black">
                    <div v-if="isVideoCaptured">
                      <video class="video-js" controls preload="auto">
                        <source :src="videoFileUrl(videoFile)" type="video/webm" />
                      </video>
                    </div>
                    <div v-else class="player-wrapper player">
                      <div id="previewSelectedVideo" />
                    </div>
                  </div>
                  <template slot="actions" class="ant-card-actions">
                    <a-button type="danger" class="tf-btn tf-btn-danger mt-2 px-4" @click="removeVideo()" icon="delete"> Delete </a-button>
                    <a-button type="primary" class="tf-btn tf-btn-primary mt-2 px-4" @click="saveVideo()" icon="save"> Save </a-button>
                  </template>
                </a-card>
              </a-col>
            </a-row>
          </a-card>
        </div>
      </a-spin>
    </a-col>
  </a-row>
</template>
<script>
import { mapState } from 'vuex';
import Uploader from '@/services/UploadService';
import AdminService from '@/services/AdminService';
export default {
  data() {
    return {
      selectedVideo: null,
      isVideoCaptured: false,
      selectedLogo: null,
      progress: -1,
      isMuted: true,
      jwPlayer: null,
    };
  },
  computed: {
    ...mapState(['settings', 'user']),
    videoFile() {
      return this.selectedVideo || this.user.user.profileVideo;
    },
  },
  mounted() {
    this.selectedVideo = this.$router.currentRoute.params.captured;
    if (this.selectedVideo) {
      this.isVideoCaptured = true;
    } else if (this.videoFile) {
      setTimeout(() => {
        this.jwPlayer = window.jwplayer('previewSelectedVideo').setup({
          file: this.videoFile,
          primary: 'flash',
          type: 'mp4',
          autostart: true,
          repeat: false,
        });
      });
    }
  },
  methods: {
    videoFileUrl(blob) {
      return URL.createObjectURL(blob);
    },
    async imageSelectChange() {
      const img = this.$refs.imagePicker.files[0];
      if (!img) {
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = e => {
        this.selectedLogo = e.target.result;
      };
    },
    captureVideo() {
      this.selectedVideo = null;
      this.$router.push({ name: 'captureVideo', query: { redirectTo: 'profileVideo' } });
    },
    async videoSelectChange() {
      const video = this.$refs.videoPicker.files[0];
      if (!video) {
        return;
      }

      this.isVideoCaptured = false;
      this.selectedVideo = video;

      setTimeout(() => {
        window.jwplayer('previewSelectedVideo').setup({
          file: URL.createObjectURL(this.selectedVideo),
          primary: 'flash',
          type: 'mp4',
          autostart: false,
          repeat: false,
        });
      });
    },
    async saveVideo() {
      const { accountId } = this.user.user;

      if (!accountId || !this.selectedVideo) {
        return;
      }

      try {
        const videoResp = await new Uploader().uploadVideoFile(this.selectedVideo, percent => (this.progress = percent));

        // update church info even it is not an administrator
        await AdminService.account.update(accountId, {
          profile_video: videoResp.Location,
        });

        this.$notification['success']({
          message: 'Uploaded successfully',
          description: 'Your profile video has been uploaded successfully!',
        });

        this.$store.dispatch('updateUser', {
          user: {
            ...this.user.user,
            profileVideo: videoResp.Location,
          },
        });
      } catch (err) {
        this.$notification['error']({
          message: err.message || this.$t('label.somethingWentWrong'),
        });

        console.log(err);
      } finally {
        this.progress = -1;
      }
    },
    async removeVideo() {
      if (this.selectedVideo) {
        this.selectedVideo = null;
      }

      const { accountId, profileVideo } = this.user.user;

      if (!accountId || !profileVideo) {
        return;
      }

      try {
        this.progress = 0;

        // update church info even it is not an administrator
        await AdminService.account.update(accountId, {
          profile_video: null,
        });

        this.$notification['success']({
          message: 'Removed successfully',
          description: 'Your profile video has been removed successfully!',
        });

        this.$store.dispatch('updateUser', {
          user: {
            ...this.user.user,
            profileVideo: null,
          },
        });
      } catch (err) {
        this.$notification['error']({
          message: err.message || this.$t('label.somethingWentWrong'),
        });

        console.log(err);
      } finally {
        this.progress = -1;
      }
    },
    unmuteJwplayer() {
      this.jwPlayer.setVolume(100);
      this.isMuted = false;
    },
  },
};
</script>
<style lang="scss">
.setup-share-story-container.content-page {
  padding: 0 !important;
  .setup-share-story {
    padding: 20px;
    .ant-btn {
      // height: 100%;
      white-space: initial;
    }
    .link-label {
      white-space: nowrap;
      flex: 0 0 auto;
      font-weight: 600;
      margin-right: 16px !important;
    }
    .link-value {
      margin-left: 8px;
      flex: 0 1 auto;
      word-break: break-all;

      & > a {
        color: #212b36;
        text-decoration: underline;
      }
    }
  }
}
.player {
  position: relative;
}
</style>
<style lang="scss" scoped>
.font-helvetica {
  line-height: 1.2;
  font-size: 28px !important;
}

.clipboard-btn {
  line-height: 24px !important;
  height: 24px !important;
  width: 24px !important;
  padding: 0 !important;
  margin-left: 16px !important;
  border-radius: 5px !important;
}

.upload-wrapper {
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.image-uploader {
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  margin: 80px auto;
  max-width: 240px;
}

.church-logo img {
  max-height: 25vw !important;
  object-fit: contain;
}

/deep/ .ant-spin-nested-loading > div > .ant-spin {
  position: fixed !important;
  top: calc(50vh - 40px);
  height: auto;
}

@media (min-width: 768px) {
  /deep/ .unfixed .ant-spin {
    transform: translateX(120px);
  }
  /deep/ .toggled .ant-spin {
    transform: translateX(36px);
  }
}
</style>
